@if (training && training.has_content) {
<div class="d-flex card">
  @if (showPreview) {
  <div class="lock">
    @switch (isLocked?.reason) { @case ('NOT_STARTED') {
    <div class="lock-badge">
      <mat-icon svgIcon="lock-filled_v2"></mat-icon>
      <span>{{getLockReasonTooltip()}}</span>
    </div>
    } @default {
    <button mat-icon-button class="lock-icon" (click)="openLockedInfoDialog()">
      <mat-icon svgIcon="lock-filled_v2"></mat-icon>
    </button>
    } }
  </div>
  }
  <div class="bg-wrapper" [class.done]="isDone(training)">
    <div class="card-image">
      <img class="w-100" [appSrcset]="training.lead_image?.url" pxWidth="600" alt="" />
      @if (training.name) {
      <div class="card-title d-flex justify-content-start align-items-end">
        <h1 class="px-3">{{training.name}}</h1>
      </div>
      }
    </div>
    @if (!showPreview) {
    <div class="training-progress">
      <app-progress-bar type="full" [total]="training.total" [current]="training.current"></app-progress-bar>
    </div>
    }
    <div class="footer">
      <button mat-stroked-button (click)="openInfoOverlay()">
        <mat-icon svgIcon="troodi_info_v2" inline="true"></mat-icon>
        <span translate>TRAININGS.COURSE_CONTENT</span>
      </button>
      <a [routerLink]="getTrainingLink(training.slug)" mat-raised-button color="primary" class="enter-training">
        <span translate>TRAININGS.BUTTON.START</span>
      </a>
    </div>
  </div>
</div>
}
